// extracted by mini-css-extract-plugin
export default {"rightPanelFooterCell":"Ow92F4QGsOnYkoMfoEU5","topLine":"b7nJAx51qvtxfi2rvTsN","icon":"q0cfqtteXttfFhvnliJC","title":"xM7fSwcDwr7VtvFKLY3r","bottomLine":"hubLIzlrAvR01IQDZKxv"};